import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

import { CORPORATE_LOGIN_PATH } from '@/constants/corporateRoutePaths'
import { CORPORATE_ENROLLMENT_QUERY_KEY } from '@/constants/corporateQueryKeys'
import { usePageStateStore } from '@/reducers'
import { useCorpStore } from '@/reducers/corporateReducer'
import { track } from '@/utils/analytics'

export const useCorporateSignOut = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const clearAuthToken = usePageStateStore.use.clearAuthToken()
  const resetEnrollmentForm = useCorpStore((state) => state.reset)

  return useCallback(() => {
    clearAuthToken()
    resetEnrollmentForm()
    queryClient.removeQueries({ queryKey: CORPORATE_ENROLLMENT_QUERY_KEY })
    track('corporate_sign_out')
    navigate(CORPORATE_LOGIN_PATH, { replace: true })
  }, [clearAuthToken, resetEnrollmentForm, navigate, queryClient])
}
